export const feedbackDialogOptions = {
  didntDisplayProperly: {
    translationKey: 'FeedbackDialog.didntDisplayProperly',
    value: "It didn't display properly"
  },
  feedbackIsIncorrect: {
    translationKey: 'FeedbackDialog.incorrectFeedback',
    value: 'The feedback is incorrect'
  },
  hardToUnderstand: {
    translationKey: 'FeedbackDialog.hardToUnderstand',
    value: "It's hard to understand"
  },
  notRelatedToPrompt: {
    translationKey: 'FeedbackDialog.notRelatedToPrompt',
    value: 'Not related to my prompt'
  },
  other: {
    translationKey: 'FeedbackDialog.other',
    value: 'Other'
  },
  responseIsIncorrect: {
    translationKey: 'FeedbackDialog.responseIsIncorrect',
    value: 'The response is incorrect'
  },
  tookTooLong: {
    translationKey: 'FeedbackDialog.tookTooLong',
    value: 'It took too long'
  }
};